// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { TaxProfile } from "../medical_master/common_pb.js";

/**
 * @generated from enum com.neulink.pharmacy.ItemType
 */
export enum ItemType {
  /**
   * @generated from enum value: ITEM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ITEM_TYPE_MEDICAL = 1;
   */
  MEDICAL = 1,

  /**
   * @generated from enum value: ITEM_TYPE_NON_MEDICAL = 2;
   */
  NON_MEDICAL = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ItemType)
proto3.util.setEnumType(ItemType, "com.neulink.pharmacy.ItemType", [
  { no: 0, name: "ITEM_TYPE_UNSPECIFIED" },
  { no: 1, name: "ITEM_TYPE_MEDICAL" },
  { no: 2, name: "ITEM_TYPE_NON_MEDICAL" },
]);

/**
 * @generated from enum com.neulink.pharmacy.DiscountType
 */
export enum DiscountType {
  /**
   * @generated from enum value: DISCOUNT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Always applied as a percentage at the time of sale (Default 10% discount)
   *
   * @generated from enum value: DISCOUNT_TYPE_ALWAYS_PERCENTAGE = 1;
   */
  ALWAYS_PERCENTAGE = 1,

  /**
   * Always applied as a fixed amount at the time of sale (Default $10 discount)
   *
   * @generated from enum value: DISCOUNT_TYPE_ALWAYS_FIXED = 2;
   */
  ALWAYS_FIXED = 2,

  /**
   * Percentage discount, can be applied at time of sale (e.g., 10% off)
   *
   * @generated from enum value: DISCOUNT_TYPE_PERCENTAGE = 3;
   */
  PERCENTAGE = 3,

  /**
   * Fixed amount discount, can be applied at time of sale (e.g., $10 off)
   *
   * @generated from enum value: DISCOUNT_TYPE_FIXED = 4;
   */
  FIXED = 4,

  /**
   * No discount applied
   *
   * @generated from enum value: DISCOUNT_TYPE_NONE = 5;
   */
  NONE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(DiscountType)
proto3.util.setEnumType(DiscountType, "com.neulink.pharmacy.DiscountType", [
  { no: 0, name: "DISCOUNT_TYPE_UNSPECIFIED" },
  { no: 1, name: "DISCOUNT_TYPE_ALWAYS_PERCENTAGE" },
  { no: 2, name: "DISCOUNT_TYPE_ALWAYS_FIXED" },
  { no: 3, name: "DISCOUNT_TYPE_PERCENTAGE" },
  { no: 4, name: "DISCOUNT_TYPE_FIXED" },
  { no: 5, name: "DISCOUNT_TYPE_NONE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.RequestType
 */
export enum RequestType {
  /**
   * Unspecified request type
   *
   * @generated from enum value: REQUEST_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Transfer request
   *
   * @generated from enum value: REQUEST_TYPE_TRANSFER = 1;
   */
  TRANSFER = 1,

  /**
   * Purchase request
   *
   * @generated from enum value: REQUEST_TYPE_PURCHASE = 2;
   */
  PURCHASE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(RequestType)
proto3.util.setEnumType(RequestType, "com.neulink.pharmacy.RequestType", [
  { no: 0, name: "REQUEST_TYPE_UNSPECIFIED" },
  { no: 1, name: "REQUEST_TYPE_TRANSFER" },
  { no: 2, name: "REQUEST_TYPE_PURCHASE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.PurchaseActivityEvent
 */
export enum PurchaseActivityEvent {
  /**
   * Unspecified event
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Purchase request created
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_REQUEST_CREATED = 1;
   */
  REQUEST_CREATED = 1,

  /**
   * Purchase order created
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_PO_CREATED = 2;
   */
  PO_CREATED = 2,

  /**
   * Item fulfillment status updated
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_ITEM_FULFILLMENT_STATUS = 3;
   */
  ITEM_FULFILLMENT_STATUS = 3,

  /**
   * Current stock status updated
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_CURRENT_STOCK_STATUS = 4;
   */
  CURRENT_STOCK_STATUS = 4,

  /**
   * Goods received
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_GOODS_RECEIVED = 5;
   */
  GOODS_RECEIVED = 5,

  /**
   * Item returned
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_ITEM_RETURNED = 6;
   */
  ITEM_RETURNED = 6,

  /**
   * Payment made
   *
   * @generated from enum value: PURCHASE_ACTIVITY_EVENT_PAYMENT_MADE = 7;
   */
  PAYMENT_MADE = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(PurchaseActivityEvent)
proto3.util.setEnumType(PurchaseActivityEvent, "com.neulink.pharmacy.PurchaseActivityEvent", [
  { no: 0, name: "PURCHASE_ACTIVITY_EVENT_UNSPECIFIED" },
  { no: 1, name: "PURCHASE_ACTIVITY_EVENT_REQUEST_CREATED" },
  { no: 2, name: "PURCHASE_ACTIVITY_EVENT_PO_CREATED" },
  { no: 3, name: "PURCHASE_ACTIVITY_EVENT_ITEM_FULFILLMENT_STATUS" },
  { no: 4, name: "PURCHASE_ACTIVITY_EVENT_CURRENT_STOCK_STATUS" },
  { no: 5, name: "PURCHASE_ACTIVITY_EVENT_GOODS_RECEIVED" },
  { no: 6, name: "PURCHASE_ACTIVITY_EVENT_ITEM_RETURNED" },
  { no: 7, name: "PURCHASE_ACTIVITY_EVENT_PAYMENT_MADE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.TransferHistoryStatus
 */
export enum TransferHistoryStatus {
  /**
   * Unspecified status
   *
   * @generated from enum value: TRANSFER_HISTORY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Transfer is pending approval
   *
   * @generated from enum value: TRANSFER_HISTORY_STATUS_PENDING_APPROVAL = 1;
   */
  PENDING_APPROVAL = 1,

  /**
   * Transfer has been completed
   *
   * @generated from enum value: TRANSFER_HISTORY_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * Transfer has been cancelled
   *
   * @generated from enum value: TRANSFER_HISTORY_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * Transfer has been rejected
   *
   * @generated from enum value: TRANSFER_HISTORY_STATUS_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * Transfer has been approved
   *
   * @generated from enum value: TRANSFER_HISTORY_STATUS_APPROVED = 5;
   */
  APPROVED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(TransferHistoryStatus)
proto3.util.setEnumType(TransferHistoryStatus, "com.neulink.pharmacy.TransferHistoryStatus", [
  { no: 0, name: "TRANSFER_HISTORY_STATUS_UNSPECIFIED" },
  { no: 1, name: "TRANSFER_HISTORY_STATUS_PENDING_APPROVAL" },
  { no: 2, name: "TRANSFER_HISTORY_STATUS_COMPLETED" },
  { no: 3, name: "TRANSFER_HISTORY_STATUS_CANCELLED" },
  { no: 4, name: "TRANSFER_HISTORY_STATUS_REJECTED" },
  { no: 5, name: "TRANSFER_HISTORY_STATUS_APPROVED" },
]);

/**
 * @generated from message com.neulink.pharmacy.InventoryItem
 */
export class InventoryItem extends Message<InventoryItem> {
  /**
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 1;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * @generated from field: string master_id = 2;
   */
  masterId = "";

  /**
   * @generated from field: string batch_number = 3;
   */
  batchNumber = "";

  /**
   * @generated from field: int64 expiry_date = 4;
   */
  expiryDate = protoInt64.zero;

  /**
   * @generated from field: bool is_valid_expiry_date = 5;
   */
  isValidExpiryDate = false;

  /**
   * @generated from field: int64 production_date = 6;
   */
  productionDate = protoInt64.zero;

  /**
   * @generated from field: bool is_valid_production_date = 7;
   */
  isValidProductionDate = false;

  /**
   * @generated from field: float cost_from_supplier = 8;
   */
  costFromSupplier = 0;

  /**
   * @generated from field: com.neulink.pharmacy.Quantity quantity = 9;
   */
  quantity?: Quantity;

  /**
   * Only for non-medical items
   *
   * @generated from field: float selling_price = 10;
   */
  sellingPrice = 0;

  /**
   * @generated from field: com.neulink.pharmacy.ItemMetadata metadata = 11;
   */
  metadata?: ItemMetadata;

  constructor(data?: PartialMessage<InventoryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 2, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expiry_date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "is_valid_expiry_date", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "production_date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "is_valid_production_date", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "cost_from_supplier", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "quantity", kind: "message", T: Quantity },
    { no: 10, name: "selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "metadata", kind: "message", T: ItemMetadata },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryItem {
    return new InventoryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryItem {
    return new InventoryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryItem {
    return new InventoryItem().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryItem | PlainMessage<InventoryItem> | undefined, b: InventoryItem | PlainMessage<InventoryItem> | undefined): boolean {
    return proto3.util.equals(InventoryItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.Quantity
 */
export class Quantity extends Message<Quantity> {
  /**
   * @generated from field: float original = 1;
   */
  original = 0;

  /**
   * @generated from field: float bonus = 2;
   */
  bonus = 0;

  constructor(data?: PartialMessage<Quantity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.Quantity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "original", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "bonus", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Quantity {
    return new Quantity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Quantity {
    return new Quantity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Quantity {
    return new Quantity().fromJsonString(jsonString, options);
  }

  static equals(a: Quantity | PlainMessage<Quantity> | undefined, b: Quantity | PlainMessage<Quantity> | undefined): boolean {
    return proto3.util.equals(Quantity, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ItemMetadata
 */
export class ItemMetadata extends Message<ItemMetadata> {
  /**
   * @generated from field: string custom_barcode = 1;
   */
  customBarcode = "";

  /**
   * @generated from field: string storage_rack = 2;
   */
  storageRack = "";

  /**
   * @generated from field: string storage_bin = 3;
   */
  storageBin = "";

  /**
   * @generated from field: string storage_location = 4;
   */
  storageLocation = "";

  /**
   * @generated from field: bool is_discountable = 5;
   */
  isDiscountable = false;

  /**
   * @generated from field: bool is_returnable = 6;
   */
  isReturnable = false;

  /**
   * @generated from field: int32 supplier_return_days_allowed = 7;
   */
  supplierReturnDaysAllowed = 0;

  /**
   * @generated from field: com.neulink.pharmacy.DiscountType discount_type = 8;
   */
  discountType = DiscountType.UNSPECIFIED;

  /**
   * @generated from field: float discount_value = 9;
   */
  discountValue = 0;

  constructor(data?: PartialMessage<ItemMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ItemMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "custom_barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "storage_rack", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "storage_bin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "storage_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_discountable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_returnable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "supplier_return_days_allowed", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "discount_type", kind: "enum", T: proto3.getEnumType(DiscountType) },
    { no: 9, name: "discount_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ItemMetadata {
    return new ItemMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ItemMetadata {
    return new ItemMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ItemMetadata {
    return new ItemMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: ItemMetadata | PlainMessage<ItemMetadata> | undefined, b: ItemMetadata | PlainMessage<ItemMetadata> | undefined): boolean {
    return proto3.util.equals(ItemMetadata, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.Filter
 */
export class Filter extends Message<Filter> {
  /**
   * Optional search query to filter inventory items
   *
   * @generated from field: string search_query = 1;
   */
  searchQuery = "";

  /**
   * Optional filter to specify the type of inventory items (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Optional filter to specify if the items are available in stock
   *
   * @generated from field: bool is_available = 3;
   */
  isAvailable = false;

  /**
   * Optional filter to specify if the items are expired
   *
   * @generated from field: bool is_expired = 4;
   */
  isExpired = false;

  /**
   * Optional filter to specify if the items are out of stock
   *
   * @generated from field: bool is_out_of_stock = 5;
   */
  isOutOfStock = false;

  /**
   * Optional filter to specify items expiring within a certain number of days
   *
   * @generated from field: int32 expiring_soon_days = 6;
   */
  expiringSoonDays = 0;

  /**
   * Optional filter to specify the storage location of the items
   *
   * @generated from field: string storage_location = 7;
   */
  storageLocation = "";

  /**
   * Optional filter to specify the master ID of the items
   *
   * @generated from field: string master_id = 8;
   */
  masterId = "";

  /**
   * Optional filter to specify the inventory ID of the items
   *
   * @generated from field: string inventory_id = 9;
   */
  inventoryId = "";

  /**
   * Optional filter to specify the stock point ID of the items
   *
   * @generated from field: string stock_point_id = 10;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<Filter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.Filter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "is_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_expired", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_out_of_stock", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "expiring_soon_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "storage_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Filter {
    return new Filter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Filter {
    return new Filter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Filter {
    return new Filter().fromJsonString(jsonString, options);
  }

  static equals(a: Filter | PlainMessage<Filter> | undefined, b: Filter | PlainMessage<Filter> | undefined): boolean {
    return proto3.util.equals(Filter, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryLineItem
 */
export class InventoryLineItem extends Message<InventoryLineItem> {
  /**
   * The master ID of the inventory item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * The batch number of the inventory item
   *
   * @generated from field: string batch_number = 2;
   */
  batchNumber = "";

  /**
   * The expiry date of the inventory item
   *
   * @generated from field: google.protobuf.Timestamp expiry_date = 3;
   */
  expiryDate?: Timestamp;

  /**
   * Indicates if the expiry date is valid
   *
   * @generated from field: bool is_valid_expiry_date = 4;
   */
  isValidExpiryDate = false;

  /**
   * The production date of the inventory item
   *
   * @generated from field: google.protobuf.Timestamp production_date = 5;
   */
  productionDate?: Timestamp;

  /**
   * Indicates if the production date is valid
   *
   * @generated from field: bool is_valid_production_date = 6;
   */
  isValidProductionDate = false;

  /**
   * The cost of the inventory item from the supplier
   *
   * @generated from field: float cost_from_supplier = 7;
   */
  costFromSupplier = 0;

  /**
   * The quantity of the inventory item
   *
   * @generated from field: com.neulink.pharmacy.Quantity input_quantity = 8;
   */
  inputQuantity?: Quantity;

  /**
   * The selling price of the inventory item (latest)
   *
   * @generated from field: float selling_price = 9;
   */
  sellingPrice = 0;

  /**
   * Metadata associated with the inventory item
   *
   * @generated from field: com.neulink.pharmacy.ItemMetadata metadata = 10;
   */
  metadata?: ItemMetadata;

  /**
   * The ID of the inventory item
   *
   * @generated from field: string inventory_id = 11;
   */
  inventoryId = "";

  /**
   * The type of the inventory item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 12;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * The trade name of the inventory item
   *
   * @generated from field: string trade_name = 13;
   */
  tradeName = "";

  /**
   * The unit type of the inventory item (e.g., "bottle", "box", "piece")
   *
   * @generated from field: string unit_type = 14;
   */
  unitType = "";

  /**
   * The unit of the inventory item (e.g., 1 bottle, 10 pieces)
   *
   * @generated from field: int32 unit = 15;
   */
  unit = 0;

  /**
   * The available quantity of the inventory item
   *
   * @generated from field: float available_quantity = 16;
   */
  availableQuantity = 0;

  /**
   * The tax profile associated with the inventory item
   *
   * @generated from field: com.neulink.pharmacy.TaxProfile tax_profile = 17;
   */
  taxProfile?: TaxProfile;

  /**
   * The barcode of the inventory item
   *
   * @generated from field: string barcode = 18;
   */
  barcode = "";

  constructor(data?: PartialMessage<InventoryLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 4, name: "is_valid_expiry_date", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "production_date", kind: "message", T: Timestamp },
    { no: 6, name: "is_valid_production_date", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "cost_from_supplier", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "input_quantity", kind: "message", T: Quantity },
    { no: 9, name: "selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "metadata", kind: "message", T: ItemMetadata },
    { no: 11, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 13, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "available_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 17, name: "tax_profile", kind: "message", T: TaxProfile },
    { no: 18, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryLineItem {
    return new InventoryLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryLineItem {
    return new InventoryLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryLineItem {
    return new InventoryLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryLineItem | PlainMessage<InventoryLineItem> | undefined, b: InventoryLineItem | PlainMessage<InventoryLineItem> | undefined): boolean {
    return proto3.util.equals(InventoryLineItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MasterInventoryLineItem
 */
export class MasterInventoryLineItem extends Message<MasterInventoryLineItem> {
  /**
   * The master ID of the inventory item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * The cost of the inventory item from the supplier
   *
   * @generated from field: float cost_from_supplier = 2;
   */
  costFromSupplier = 0;

  /**
   * The selling price of the inventory item (latest)
   *
   * @generated from field: float selling_price = 3;
   */
  sellingPrice = 0;

  /**
   * The type of the inventory item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 4;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * The trade name of the inventory item
   *
   * @generated from field: string trade_name = 5;
   */
  tradeName = "";

  /**
   * The unit type of the inventory item (e.g., "bottle", "box", "piece")
   *
   * @generated from field: string unit_type = 6;
   */
  unitType = "";

  /**
   * The unit of the inventory item (e.g., 1 bottle, 10 pieces)
   *
   * @generated from field: int32 unit = 7;
   */
  unit = 0;

  /**
   * The available quantity of the inventory item
   *
   * @generated from field: float available_quantity = 8;
   */
  availableQuantity = 0;

  /**
   * The barcode of the inventory item
   *
   * @generated from field: string barcode = 9;
   */
  barcode = "";

  /**
   * The stock splits across different stock points or branches
   *
   * @generated from field: repeated com.neulink.pharmacy.StockSplit stock_splits = 10;
   */
  stockSplits: StockSplit[] = [];

  /**
   * The average daily sales of the inventory item
   *
   * @generated from field: float average_daily_sales = 11;
   */
  averageDailySales = 0;

  /**
   * The average weekly sales of the inventory item
   *
   * @generated from field: float average_weekly_sales = 12;
   */
  averageWeeklySales = 0;

  /**
   * The average monthly sales of the inventory item
   *
   * @generated from field: float average_monthly_sales = 13;
   */
  averageMonthlySales = 0;

  /**
   * The total daily sales of the inventory item
   *
   * @generated from field: float total_daily_sales = 14;
   */
  totalDailySales = 0;

  /**
   * The total weekly sales of the inventory item
   *
   * @generated from field: float total_weekly_sales = 15;
   */
  totalWeeklySales = 0;

  /**
   * The total monthly sales of the inventory item
   *
   * @generated from field: float total_monthly_sales = 16;
   */
  totalMonthlySales = 0;

  /**
   * The estimated number of days the current stock will last based on sales
   *
   * @generated from field: float days_of_supply_remaining = 17;
   */
  daysOfSupplyRemaining = 0;

  constructor(data?: PartialMessage<MasterInventoryLineItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MasterInventoryLineItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cost_from_supplier", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "selling_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 5, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "available_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "barcode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "stock_splits", kind: "message", T: StockSplit, repeated: true },
    { no: 11, name: "average_daily_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 12, name: "average_weekly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "average_monthly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 14, name: "total_daily_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "total_weekly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "total_monthly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 17, name: "days_of_supply_remaining", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MasterInventoryLineItem {
    return new MasterInventoryLineItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MasterInventoryLineItem {
    return new MasterInventoryLineItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MasterInventoryLineItem {
    return new MasterInventoryLineItem().fromJsonString(jsonString, options);
  }

  static equals(a: MasterInventoryLineItem | PlainMessage<MasterInventoryLineItem> | undefined, b: MasterInventoryLineItem | PlainMessage<MasterInventoryLineItem> | undefined): boolean {
    return proto3.util.equals(MasterInventoryLineItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockSplit
 */
export class StockSplit extends Message<StockSplit> {
  /**
   * The ID of the stock point or branch
   *
   * @generated from field: string location_id = 1;
   */
  locationId = "";

  /**
   * The name of the stock point or branch
   *
   * @generated from field: string location_name = 2;
   */
  locationName = "";

  /**
   * The available quantity of the inventory item at this location
   *
   * @generated from field: float available_quantity = 3;
   */
  availableQuantity = 0;

  constructor(data?: PartialMessage<StockSplit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockSplit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "location_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "location_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "available_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockSplit {
    return new StockSplit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockSplit {
    return new StockSplit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockSplit {
    return new StockSplit().fromJsonString(jsonString, options);
  }

  static equals(a: StockSplit | PlainMessage<StockSplit> | undefined, b: StockSplit | PlainMessage<StockSplit> | undefined): boolean {
    return proto3.util.equals(StockSplit, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.NonMedicalInventoryPriceHistoryItem
 */
export class NonMedicalInventoryPriceHistoryItem extends Message<NonMedicalInventoryPriceHistoryItem> {
  /**
   * The ID of the price history item
   *
   * @generated from field: string price_id = 1;
   */
  priceId = "";

  /**
   * The price of the non-medical inventory item
   *
   * @generated from field: float price = 2;
   */
  price = 0;

  /**
   * The date when the price becomes effective
   *
   * @generated from field: google.protobuf.Timestamp effective_date = 3;
   */
  effectiveDate?: Timestamp;

  /**
   * Indicates if this price is currently active
   *
   * @generated from field: bool is_current_active = 4;
   */
  isCurrentActive = false;

  constructor(data?: PartialMessage<NonMedicalInventoryPriceHistoryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.NonMedicalInventoryPriceHistoryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "price_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "effective_date", kind: "message", T: Timestamp },
    { no: 4, name: "is_current_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NonMedicalInventoryPriceHistoryItem {
    return new NonMedicalInventoryPriceHistoryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NonMedicalInventoryPriceHistoryItem {
    return new NonMedicalInventoryPriceHistoryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NonMedicalInventoryPriceHistoryItem {
    return new NonMedicalInventoryPriceHistoryItem().fromJsonString(jsonString, options);
  }

  static equals(a: NonMedicalInventoryPriceHistoryItem | PlainMessage<NonMedicalInventoryPriceHistoryItem> | undefined, b: NonMedicalInventoryPriceHistoryItem | PlainMessage<NonMedicalInventoryPriceHistoryItem> | undefined): boolean {
    return proto3.util.equals(NonMedicalInventoryPriceHistoryItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockPointLevelView
 */
export class StockPointLevelView extends Message<StockPointLevelView> {
  /**
   * The total value of the inventory at this stock point
   *
   * @generated from field: float total_inventory_value = 1;
   */
  totalInventoryValue = 0;

  /**
   * The total number of items in the inventory at this stock point
   *
   * @generated from field: int32 total_items = 2;
   */
  totalItems = 0;

  /**
   * The number of items expiring soon at this stock point
   *
   * @generated from field: int32 expiring_soon_items = 3;
   */
  expiringSoonItems = 0;

  /**
   * The number of items that are out of stock at this stock point
   *
   * @generated from field: int32 out_of_stock_items = 4;
   */
  outOfStockItems = 0;

  /**
   * The number of items that are expired at this stock point
   *
   * @generated from field: int32 expired_items = 5;
   */
  expiredItems = 0;

  /**
   * The trends of inventory value over time
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryValueTrend inventory_value_trends = 6;
   */
  inventoryValueTrends: InventoryValueTrend[] = [];

  /**
   * The top suppliers for this stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.TopSupplier top_suppliers = 7;
   */
  topSuppliers: TopSupplier[] = [];

  /**
   * The fast-moving items at this stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItem fast_moving_items = 8;
   */
  fastMovingItems: MovingItem[] = [];

  /**
   * The slow-moving items at this stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItem slow_moving_items = 9;
   */
  slowMovingItems: MovingItem[] = [];

  /**
   * The timeline of expiry risk for items at this stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.ExpiryRiskTimeline expiry_risk_timeline = 10;
   */
  expiryRiskTimeline: ExpiryRiskTimeline[] = [];

  /**
   * The distribution of items by category at this stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.CategoryWiseDistribution category_wise_distribution = 11;
   */
  categoryWiseDistribution: CategoryWiseDistribution[] = [];

  /**
   * The health score of the inventory at this stock point
   *
   * @generated from field: com.neulink.pharmacy.HealthScore health_score = 12;
   */
  healthScore?: HealthScore;

  /**
   * The distribution of items by stock status at this stock point
   *
   * @generated from field: repeated com.neulink.pharmacy.StockStatusDistribution stock_status_distribution = 13;
   */
  stockStatusDistribution: StockStatusDistribution[] = [];

  constructor(data?: PartialMessage<StockPointLevelView>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockPointLevelView";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_inventory_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "expiring_soon_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "out_of_stock_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "expired_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "inventory_value_trends", kind: "message", T: InventoryValueTrend, repeated: true },
    { no: 7, name: "top_suppliers", kind: "message", T: TopSupplier, repeated: true },
    { no: 8, name: "fast_moving_items", kind: "message", T: MovingItem, repeated: true },
    { no: 9, name: "slow_moving_items", kind: "message", T: MovingItem, repeated: true },
    { no: 10, name: "expiry_risk_timeline", kind: "message", T: ExpiryRiskTimeline, repeated: true },
    { no: 11, name: "category_wise_distribution", kind: "message", T: CategoryWiseDistribution, repeated: true },
    { no: 12, name: "health_score", kind: "message", T: HealthScore },
    { no: 13, name: "stock_status_distribution", kind: "message", T: StockStatusDistribution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockPointLevelView {
    return new StockPointLevelView().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockPointLevelView {
    return new StockPointLevelView().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockPointLevelView {
    return new StockPointLevelView().fromJsonString(jsonString, options);
  }

  static equals(a: StockPointLevelView | PlainMessage<StockPointLevelView> | undefined, b: StockPointLevelView | PlainMessage<StockPointLevelView> | undefined): boolean {
    return proto3.util.equals(StockPointLevelView, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryValueTrend
 */
export class InventoryValueTrend extends Message<InventoryValueTrend> {
  /**
   * The date of the inventory value trend
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * The value of the inventory on that date
   *
   * @generated from field: float value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<InventoryValueTrend>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryValueTrend";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryValueTrend {
    return new InventoryValueTrend().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryValueTrend {
    return new InventoryValueTrend().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryValueTrend {
    return new InventoryValueTrend().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryValueTrend | PlainMessage<InventoryValueTrend> | undefined, b: InventoryValueTrend | PlainMessage<InventoryValueTrend> | undefined): boolean {
    return proto3.util.equals(InventoryValueTrend, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TopSupplier
 */
export class TopSupplier extends Message<TopSupplier> {
  /**
   * The ID of the supplier
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * The name of the supplier
   *
   * @generated from field: string supplier_name = 2;
   */
  supplierName = "";

  /**
   * The total value of items supplied by this supplier
   *
   * @generated from field: float total_value = 3;
   */
  totalValue = 0;

  /**
   * The total number of items supplied by this supplier
   *
   * @generated from field: int32 total_items = 4;
   */
  totalItems = 0;

  constructor(data?: PartialMessage<TopSupplier>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TopSupplier";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TopSupplier {
    return new TopSupplier().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TopSupplier {
    return new TopSupplier().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TopSupplier {
    return new TopSupplier().fromJsonString(jsonString, options);
  }

  static equals(a: TopSupplier | PlainMessage<TopSupplier> | undefined, b: TopSupplier | PlainMessage<TopSupplier> | undefined): boolean {
    return proto3.util.equals(TopSupplier, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.MovingItem
 */
export class MovingItem extends Message<MovingItem> {
  /**
   * The master ID of the fast-moving item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * The trade name of the fast-moving item
   *
   * @generated from field: string trade_name = 2;
   */
  tradeName = "";

  /**
   * The date when the item was last moved
   *
   * @generated from field: google.protobuf.Timestamp last_moved_date = 3;
   */
  lastMovedDate?: Timestamp;

  /**
   * The type of the fast-moving item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 4;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * The average monthly movement of the fast-moving item
   *
   * @generated from field: float average_monthly_movement = 5;
   */
  averageMonthlyMovement = 0;

  constructor(data?: PartialMessage<MovingItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.MovingItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_moved_date", kind: "message", T: Timestamp },
    { no: 4, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 5, name: "average_monthly_movement", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MovingItem {
    return new MovingItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MovingItem {
    return new MovingItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MovingItem {
    return new MovingItem().fromJsonString(jsonString, options);
  }

  static equals(a: MovingItem | PlainMessage<MovingItem> | undefined, b: MovingItem | PlainMessage<MovingItem> | undefined): boolean {
    return proto3.util.equals(MovingItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ExpiryRiskTimeline
 */
export class ExpiryRiskTimeline extends Message<ExpiryRiskTimeline> {
  /**
   * The month range for the expiry risk (e.g., "Jan 2023 - Mar 2023")
   *
   * @generated from field: string month_range = 1;
   */
  monthRange = "";

  /**
   * The number of items at risk of expiry on that date
   *
   * @generated from field: int32 items_at_risk = 2;
   */
  itemsAtRisk = 0;

  constructor(data?: PartialMessage<ExpiryRiskTimeline>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ExpiryRiskTimeline";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "month_range", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "items_at_risk", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExpiryRiskTimeline {
    return new ExpiryRiskTimeline().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExpiryRiskTimeline {
    return new ExpiryRiskTimeline().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExpiryRiskTimeline {
    return new ExpiryRiskTimeline().fromJsonString(jsonString, options);
  }

  static equals(a: ExpiryRiskTimeline | PlainMessage<ExpiryRiskTimeline> | undefined, b: ExpiryRiskTimeline | PlainMessage<ExpiryRiskTimeline> | undefined): boolean {
    return proto3.util.equals(ExpiryRiskTimeline, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CategoryWiseDistribution
 */
export class CategoryWiseDistribution extends Message<CategoryWiseDistribution> {
  /**
   * The category of items (e.g., "Medical", "Non-Medical")
   *
   * @generated from field: string category = 1;
   */
  category = "";

  /**
   * The total number of items in this category
   *
   * @generated from field: int32 total_items = 2;
   */
  totalItems = 0;

  constructor(data?: PartialMessage<CategoryWiseDistribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CategoryWiseDistribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CategoryWiseDistribution {
    return new CategoryWiseDistribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CategoryWiseDistribution {
    return new CategoryWiseDistribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CategoryWiseDistribution {
    return new CategoryWiseDistribution().fromJsonString(jsonString, options);
  }

  static equals(a: CategoryWiseDistribution | PlainMessage<CategoryWiseDistribution> | undefined, b: CategoryWiseDistribution | PlainMessage<CategoryWiseDistribution> | undefined): boolean {
    return proto3.util.equals(CategoryWiseDistribution, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.HealthScore
 */
export class HealthScore extends Message<HealthScore> {
  /**
   * The score based on stock availability
   *
   * @generated from field: float stock_availability_score = 1;
   */
  stockAvailabilityScore = 0;

  /**
   * The score based on inventory turnover
   *
   * @generated from field: float inventory_turnover_score = 2;
   */
  inventoryTurnoverScore = 0;

  /**
   * The score based on expiry risk
   *
   * @generated from field: float expiry_risk_score = 3;
   */
  expiryRiskScore = 0;

  /**
   * The minimum number of days until the stock lasts
   *
   * @generated from field: int32 min_days_until_stock_lasts = 4;
   */
  minDaysUntilStockLasts = 0;

  /**
   * The maximum number of days until the stock lasts
   *
   * @generated from field: int32 max_days_until_stock_lasts = 5;
   */
  maxDaysUntilStockLasts = 0;

  /**
   * The overall health score of the inventory
   *
   * @generated from field: float overall_health_score = 6;
   */
  overallHealthScore = 0;

  constructor(data?: PartialMessage<HealthScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.HealthScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stock_availability_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "inventory_turnover_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "expiry_risk_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "min_days_until_stock_lasts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "max_days_until_stock_lasts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "overall_health_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HealthScore {
    return new HealthScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HealthScore {
    return new HealthScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HealthScore {
    return new HealthScore().fromJsonString(jsonString, options);
  }

  static equals(a: HealthScore | PlainMessage<HealthScore> | undefined, b: HealthScore | PlainMessage<HealthScore> | undefined): boolean {
    return proto3.util.equals(HealthScore, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.BranchLevelView
 */
export class BranchLevelView extends Message<BranchLevelView> {
  /**
   * The list of stock points in the branch
   *
   * @generated from field: repeated com.neulink.pharmacy.StockPointOverview stock_points = 1;
   */
  stockPoints: StockPointOverview[] = [];

  /**
   * The total value of the inventory across all stock points in the branch
   *
   * @generated from field: float total_inventory_value = 2;
   */
  totalInventoryValue = 0;

  /**
   * The total number of items across all stock points in the branch
   *
   * @generated from field: int32 total_items = 3;
   */
  totalItems = 0;

  /**
   * The number of items expiring soon across all stock points in the branch
   *
   * @generated from field: int32 expiring_soon_items = 4;
   */
  expiringSoonItems = 0;

  /**
   * The number of items that are out of stock across all stock points in the branch
   *
   * @generated from field: int32 out_of_stock_items = 5;
   */
  outOfStockItems = 0;

  /**
   * The number of items that are expired across all stock points in the branch
   *
   * @generated from field: int32 expired_items = 6;
   */
  expiredItems = 0;

  /**
   * The trends of inventory value over time across all stock points
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryValueTrend inventory_value_trends = 7;
   */
  inventoryValueTrends: InventoryValueTrend[] = [];

  /**
   * The top suppliers across all stock points in the branch
   *
   * @generated from field: repeated com.neulink.pharmacy.TopSupplier top_suppliers = 8;
   */
  topSuppliers: TopSupplier[] = [];

  /**
   * The fast-moving items across all stock points in the branch
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItem fast_moving_items = 9;
   */
  fastMovingItems: MovingItem[] = [];

  /**
   * The slow-moving items across all stock points in the branch
   *
   * @generated from field: repeated com.neulink.pharmacy.MovingItem slow_moving_items = 10;
   */
  slowMovingItems: MovingItem[] = [];

  /**
   * The timeline of expiry risk for items across all stock points in the branch
   *
   * @generated from field: repeated com.neulink.pharmacy.ExpiryRiskTimeline expiry_risk_timeline = 11;
   */
  expiryRiskTimeline: ExpiryRiskTimeline[] = [];

  /**
   * The distribution of items by category across all stock points in the branch
   *
   * @generated from field: repeated com.neulink.pharmacy.CategoryWiseDistribution category_wise_distribution = 12;
   */
  categoryWiseDistribution: CategoryWiseDistribution[] = [];

  /**
   * The health score of the inventory across all stock points in the branch
   *
   * @generated from field: com.neulink.pharmacy.HealthScore health_score = 13;
   */
  healthScore?: HealthScore;

  /**
   * The distribution of items by stock status across all stock points
   *
   * @generated from field: repeated com.neulink.pharmacy.StockStatusDistribution stock_status_distribution = 14;
   */
  stockStatusDistribution: StockStatusDistribution[] = [];

  constructor(data?: PartialMessage<BranchLevelView>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.BranchLevelView";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stock_points", kind: "message", T: StockPointOverview, repeated: true },
    { no: 2, name: "total_inventory_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "expiring_soon_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "out_of_stock_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "expired_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "inventory_value_trends", kind: "message", T: InventoryValueTrend, repeated: true },
    { no: 8, name: "top_suppliers", kind: "message", T: TopSupplier, repeated: true },
    { no: 9, name: "fast_moving_items", kind: "message", T: MovingItem, repeated: true },
    { no: 10, name: "slow_moving_items", kind: "message", T: MovingItem, repeated: true },
    { no: 11, name: "expiry_risk_timeline", kind: "message", T: ExpiryRiskTimeline, repeated: true },
    { no: 12, name: "category_wise_distribution", kind: "message", T: CategoryWiseDistribution, repeated: true },
    { no: 13, name: "health_score", kind: "message", T: HealthScore },
    { no: 14, name: "stock_status_distribution", kind: "message", T: StockStatusDistribution, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BranchLevelView {
    return new BranchLevelView().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BranchLevelView {
    return new BranchLevelView().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BranchLevelView {
    return new BranchLevelView().fromJsonString(jsonString, options);
  }

  static equals(a: BranchLevelView | PlainMessage<BranchLevelView> | undefined, b: BranchLevelView | PlainMessage<BranchLevelView> | undefined): boolean {
    return proto3.util.equals(BranchLevelView, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockPointOverview
 */
export class StockPointOverview extends Message<StockPointOverview> {
  /**
   * @generated from field: string stock_point_id = 1;
   */
  stockPointId = "";

  /**
   * The name of the stock point
   *
   * @generated from field: string stock_point_name = 2;
   */
  stockPointName = "";

  /**
   * The total number of items in this stock point
   *
   * @generated from field: int32 total_items = 3;
   */
  totalItems = 0;

  constructor(data?: PartialMessage<StockPointOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockPointOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockPointOverview {
    return new StockPointOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockPointOverview {
    return new StockPointOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockPointOverview {
    return new StockPointOverview().fromJsonString(jsonString, options);
  }

  static equals(a: StockPointOverview | PlainMessage<StockPointOverview> | undefined, b: StockPointOverview | PlainMessage<StockPointOverview> | undefined): boolean {
    return proto3.util.equals(StockPointOverview, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CompanyLevelView
 */
export class CompanyLevelView extends Message<CompanyLevelView> {
  /**
   * The list of branches in the company
   *
   * @generated from field: repeated com.neulink.pharmacy.BranchOverview branches = 1;
   */
  branches: BranchOverview[] = [];

  constructor(data?: PartialMessage<CompanyLevelView>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CompanyLevelView";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "branches", kind: "message", T: BranchOverview, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CompanyLevelView {
    return new CompanyLevelView().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CompanyLevelView {
    return new CompanyLevelView().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CompanyLevelView {
    return new CompanyLevelView().fromJsonString(jsonString, options);
  }

  static equals(a: CompanyLevelView | PlainMessage<CompanyLevelView> | undefined, b: CompanyLevelView | PlainMessage<CompanyLevelView> | undefined): boolean {
    return proto3.util.equals(CompanyLevelView, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.BranchOverview
 */
export class BranchOverview extends Message<BranchOverview> {
  /**
   * The ID of the branch
   *
   * @generated from field: string branch_id = 1;
   */
  branchId = "";

  /**
   * The name of the branch
   *
   * @generated from field: string branch_name = 2;
   */
  branchName = "";

  /**
   * The total value of the inventory in this branch
   *
   * @generated from field: float total_inventory_value = 3;
   */
  totalInventoryValue = 0;

  /**
   * The total number of items in this branch
   *
   * @generated from field: int32 total_items = 4;
   */
  totalItems = 0;

  /**
   * The number of items expiring soon in this branch
   *
   * @generated from field: int32 expiring_soon_items = 5;
   */
  expiringSoonItems = 0;

  /**
   * The number of items that are out of stock in this branch
   *
   * @generated from field: int32 out_of_stock_items = 6;
   */
  outOfStockItems = 0;

  /**
   * The number of items that are expired in this branch
   *
   * @generated from field: int32 expired_items = 7;
   */
  expiredItems = 0;

  constructor(data?: PartialMessage<BranchOverview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.BranchOverview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "branch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_inventory_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "expiring_soon_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "out_of_stock_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "expired_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BranchOverview {
    return new BranchOverview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BranchOverview {
    return new BranchOverview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BranchOverview {
    return new BranchOverview().fromJsonString(jsonString, options);
  }

  static equals(a: BranchOverview | PlainMessage<BranchOverview> | undefined, b: BranchOverview | PlainMessage<BranchOverview> | undefined): boolean {
    return proto3.util.equals(BranchOverview, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockStatusDistribution
 */
export class StockStatusDistribution extends Message<StockStatusDistribution> {
  /**
   * The status of the stock (e.g., "Available", "Out of Stock", "Expired")
   *
   * @generated from field: string status = 1;
   */
  status = "";

  /**
   * The number of items with this status
   *
   * @generated from field: int32 item_count = 2;
   */
  itemCount = 0;

  constructor(data?: PartialMessage<StockStatusDistribution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockStatusDistribution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockStatusDistribution {
    return new StockStatusDistribution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockStatusDistribution {
    return new StockStatusDistribution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockStatusDistribution {
    return new StockStatusDistribution().fromJsonString(jsonString, options);
  }

  static equals(a: StockStatusDistribution | PlainMessage<StockStatusDistribution> | undefined, b: StockStatusDistribution | PlainMessage<StockStatusDistribution> | undefined): boolean {
    return proto3.util.equals(StockStatusDistribution, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TransferRequestItem
 */
export class TransferRequestItem extends Message<TransferRequestItem> {
  /**
   * The master ID of the inventory item to be transferred
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * The batch ID of the inventory item to be transferred (optional)
   *
   * @generated from field: string batch_id = 2;
   */
  batchId = "";

  /**
   * The type of the inventory item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 3;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * The type of request (e.g., TRANSFER, PURCHASE)
   *
   * @generated from field: com.neulink.pharmacy.RequestType request_type = 4;
   */
  requestType = RequestType.UNSPECIFIED;

  /**
   * The quantity of the inventory item to be transferred
   *
   * @generated from field: float quantity = 5;
   */
  quantity = 0;

  /**
   * Optional notes regarding the transfer request
   *
   * @generated from field: string notes = 6;
   */
  notes = "";

  constructor(data?: PartialMessage<TransferRequestItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferRequestItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "batch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 4, name: "request_type", kind: "enum", T: proto3.getEnumType(RequestType) },
    { no: 5, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferRequestItem {
    return new TransferRequestItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferRequestItem {
    return new TransferRequestItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferRequestItem {
    return new TransferRequestItem().fromJsonString(jsonString, options);
  }

  static equals(a: TransferRequestItem | PlainMessage<TransferRequestItem> | undefined, b: TransferRequestItem | PlainMessage<TransferRequestItem> | undefined): boolean {
    return proto3.util.equals(TransferRequestItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseActivityItem
 */
export class PurchaseActivityItem extends Message<PurchaseActivityItem> {
  /**
   * The timestamp of the purchase activity event
   *
   * @generated from field: google.protobuf.Timestamp event_timestamp = 1;
   */
  eventTimestamp?: Timestamp;

  /**
   * The type of purchase activity event
   *
   * @generated from field: com.neulink.pharmacy.PurchaseActivityEvent event_type = 2;
   */
  eventType = PurchaseActivityEvent.UNSPECIFIED;

  /**
   * Additional details about the event, such as purchase order ID, purchase request ID, etc.
   *
   * @generated from field: map<string, string> event_details = 3;
   */
  eventDetails: { [key: string]: string } = {};

  /**
   * The ID of the related item (e.g., purchase order ID, purchase request ID)
   *
   * @generated from field: string related_item_id = 4;
   */
  relatedItemId = "";

  /**
   * The list of inventory items involved in the purchase activity
   *
   * @generated from field: repeated com.neulink.pharmacy.ActivityItem items = 5;
   */
  items: ActivityItem[] = [];

  constructor(data?: PartialMessage<PurchaseActivityItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseActivityItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "event_timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "event_type", kind: "enum", T: proto3.getEnumType(PurchaseActivityEvent) },
    { no: 3, name: "event_details", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "related_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "items", kind: "message", T: ActivityItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseActivityItem {
    return new PurchaseActivityItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseActivityItem {
    return new PurchaseActivityItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseActivityItem {
    return new PurchaseActivityItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseActivityItem | PlainMessage<PurchaseActivityItem> | undefined, b: PurchaseActivityItem | PlainMessage<PurchaseActivityItem> | undefined): boolean {
    return proto3.util.equals(PurchaseActivityItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ActivityItem
 */
export class ActivityItem extends Message<ActivityItem> {
  /**
   * The name of the inventory item
   *
   * @generated from field: string item = 1;
   */
  item = "";

  /**
   * The unit of the inventory item (e.g., 15 tablets)
   *
   * @generated from field: int32 unit = 2;
   */
  unit = 0;

  /**
   * The quantity of the inventory item involved in the activity
   *
   * @generated from field: float quantity = 3;
   */
  quantity = 0;

  /**
   * The type of the inventory item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 4;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * The master ID of the inventory item
   *
   * @generated from field: string master_id = 5;
   */
  masterId = "";

  /**
   * The type of unit for the inventory item (e.g., "Tablets (Strip)")
   *
   * @generated from field: string unit_type = 6;
   */
  unitType = "";

  /**
   * The fulfillment status of the inventory item (e.g., "Ordered (Pending Receipt)", "Received", "Returned")
   *
   * @generated from field: string fulfillment_status = 7;
   */
  fulfillmentStatus = "";

  /**
   * The quantity requested for the inventory item
   *
   * @generated from field: float requested_quantity = 8;
   */
  requestedQuantity = 0;

  /**
   * The quantity ordered for the inventory item
   *
   * @generated from field: float ordered_quantity = 9;
   */
  orderedQuantity = 0;

  /**
   * The quantity received for the inventory item
   *
   * @generated from field: float received_quantity = 10;
   */
  receivedQuantity = 0;

  /**
   * The batch number of the inventory item
   *
   * @generated from field: string batch_number = 11;
   */
  batchNumber = "";

  /**
   * The quantity received for the inventory item
   *
   * @generated from field: float quantity_received = 12;
   */
  quantityReceived = 0;

  /**
   * The category of quantity (e.g., BONUS, ORIGINAL)
   *
   * @generated from field: string quantity_category = 13;
   */
  quantityCategory = "";

  /**
   * The name of the stock point where the item is located
   *
   * @generated from field: string stock_point_name = 14;
   */
  stockPointName = "";

  /**
   * The current quantity of the inventory item in stock
   *
   * @generated from field: float current_quantity = 15;
   */
  currentQuantity = 0;

  /**
   * The expiry date of the inventory item
   *
   * @generated from field: google.protobuf.Timestamp expiry_date = 16;
   */
  expiryDate?: Timestamp;

  /**
   * The quantity returned for the inventory item
   *
   * @generated from field: float quantity_returned = 17;
   */
  quantityReturned = 0;

  constructor(data?: PartialMessage<ActivityItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ActivityItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "item", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 5, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "fulfillment_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "requested_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "ordered_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "received_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "quantity_received", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "quantity_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "current_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "expiry_date", kind: "message", T: Timestamp },
    { no: 17, name: "quantity_returned", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivityItem {
    return new ActivityItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivityItem {
    return new ActivityItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivityItem {
    return new ActivityItem().fromJsonString(jsonString, options);
  }

  static equals(a: ActivityItem | PlainMessage<ActivityItem> | undefined, b: ActivityItem | PlainMessage<ActivityItem> | undefined): boolean {
    return proto3.util.equals(ActivityItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.TransferHistoryItem
 */
export class TransferHistoryItem extends Message<TransferHistoryItem> {
  /**
   * @generated from field: string transfer_request_id = 1;
   */
  transferRequestId = "";

  /**
   * @generated from field: string source_stock_point_id = 2;
   */
  sourceStockPointId = "";

  /**
   * @generated from field: string destination_stock_point_id = 3;
   */
  destinationStockPointId = "";

  /**
   * @generated from field: string source_stock_point_name = 4;
   */
  sourceStockPointName = "";

  /**
   * @generated from field: string destination_stock_point_name = 5;
   */
  destinationStockPointName = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: com.neulink.pharmacy.TransferHistoryStatus status = 7;
   */
  status = TransferHistoryStatus.UNSPECIFIED;

  /**
   * @generated from field: com.neulink.pharmacy.UserInfoInventory requested_by = 8;
   */
  requestedBy?: UserInfoInventory;

  /**
   * @generated from field: repeated com.neulink.pharmacy.InventoryLineItem items = 9;
   */
  items: InventoryLineItem[] = [];

  /**
   * @generated from field: string source_branch_code = 10;
   */
  sourceBranchCode = "";

  /**
   * @generated from field: string source_branch_name = 11;
   */
  sourceBranchName = "";

  /**
   * @generated from field: string destination_branch_code = 12;
   */
  destinationBranchCode = "";

  /**
   * @generated from field: string destination_branch_name = 13;
   */
  destinationBranchName = "";

  constructor(data?: PartialMessage<TransferHistoryItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.TransferHistoryItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transfer_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source_stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "destination_stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source_stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "destination_stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(TransferHistoryStatus) },
    { no: 8, name: "requested_by", kind: "message", T: UserInfoInventory },
    { no: 9, name: "items", kind: "message", T: InventoryLineItem, repeated: true },
    { no: 10, name: "source_branch_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "source_branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "destination_branch_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "destination_branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TransferHistoryItem {
    return new TransferHistoryItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TransferHistoryItem {
    return new TransferHistoryItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TransferHistoryItem {
    return new TransferHistoryItem().fromJsonString(jsonString, options);
  }

  static equals(a: TransferHistoryItem | PlainMessage<TransferHistoryItem> | undefined, b: TransferHistoryItem | PlainMessage<TransferHistoryItem> | undefined): boolean {
    return proto3.util.equals(TransferHistoryItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UserInfoInventory
 */
export class UserInfoInventory extends Message<UserInfoInventory> {
  /**
   * ID of the user
   *
   * @generated from field: int32 user_id = 1;
   */
  userId = 0;

  /**
   * Username of the user
   *
   * @generated from field: string username = 2;
   */
  username = "";

  /**
   * Full name of the user
   *
   * @generated from field: string full_name = 3;
   */
  fullName = "";

  constructor(data?: PartialMessage<UserInfoInventory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UserInfoInventory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserInfoInventory {
    return new UserInfoInventory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserInfoInventory {
    return new UserInfoInventory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserInfoInventory {
    return new UserInfoInventory().fromJsonString(jsonString, options);
  }

  static equals(a: UserInfoInventory | PlainMessage<UserInfoInventory> | undefined, b: UserInfoInventory | PlainMessage<UserInfoInventory> | undefined): boolean {
    return proto3.util.equals(UserInfoInventory, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockMovementReportItem
 */
export class StockMovementReportItem extends Message<StockMovementReportItem> {
  /**
   * Month of the stock movement report item
   *
   * @generated from field: int32 month = 1;
   */
  month = 0;

  /**
   * Year of the stock movement report item
   *
   * @generated from field: int32 year = 2;
   */
  year = 0;

  /**
   * Opening stock for the month
   *
   * @generated from field: float opening_stock = 3;
   */
  openingStock = 0;

  /**
   * Closing stock for the month
   *
   * @generated from field: float closing_stock = 4;
   */
  closingStock = 0;

  /**
   * Net movement of stock for the month
   *
   * @generated from field: float net_movement = 5;
   */
  netMovement = 0;

  constructor(data?: PartialMessage<StockMovementReportItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockMovementReportItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "opening_stock", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "closing_stock", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "net_movement", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockMovementReportItem {
    return new StockMovementReportItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockMovementReportItem {
    return new StockMovementReportItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockMovementReportItem {
    return new StockMovementReportItem().fromJsonString(jsonString, options);
  }

  static equals(a: StockMovementReportItem | PlainMessage<StockMovementReportItem> | undefined, b: StockMovementReportItem | PlainMessage<StockMovementReportItem> | undefined): boolean {
    return proto3.util.equals(StockMovementReportItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryLedgerItem
 */
export class InventoryLedgerItem extends Message<InventoryLedgerItem> {
  /**
   * The date of the transaction
   *
   * @generated from field: google.protobuf.Timestamp transaction_date = 1;
   */
  transactionDate?: Timestamp;

  /**
   * The change in quantity for the transaction
   *
   * @generated from field: float quantity_change = 2;
   */
  quantityChange = 0;

  /**
   * The category of quantity (e.g., BONUS, ORIGINAL)
   *
   * @generated from field: string quantity_category = 3;
   */
  quantityCategory = "";

  /**
   * The name of the stock point where the transaction occurred
   *
   * @generated from field: string stock_point_name = 4;
   */
  stockPointName = "";

  /**
   * The username of the user who performed the transaction
   *
   * @generated from field: string username = 5;
   */
  username = "";

  /**
   * The reference ID of the transaction (e.g., purchase order ID, transfer request ID)
   *
   * @generated from field: string transaction_reference_id = 6;
   */
  transactionReferenceId = "";

  /**
   * Optional notes regarding the transaction
   *
   * @generated from field: string notes = 7;
   */
  notes = "";

  /**
   * The type of transaction (e.g., "Purchase", "Transfer", "Return")
   *
   * @generated from field: string transaction_type = 8;
   */
  transactionType = "";

  constructor(data?: PartialMessage<InventoryLedgerItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryLedgerItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "transaction_date", kind: "message", T: Timestamp },
    { no: 2, name: "quantity_change", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "quantity_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "transaction_reference_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "transaction_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryLedgerItem {
    return new InventoryLedgerItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryLedgerItem {
    return new InventoryLedgerItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryLedgerItem {
    return new InventoryLedgerItem().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryLedgerItem | PlainMessage<InventoryLedgerItem> | undefined, b: InventoryLedgerItem | PlainMessage<InventoryLedgerItem> | undefined): boolean {
    return proto3.util.equals(InventoryLedgerItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryStockPointSplitItem
 */
export class InventoryStockPointSplitItem extends Message<InventoryStockPointSplitItem> {
  /**
   * The ID of the stock point
   *
   * @generated from field: string stock_point_id = 1;
   */
  stockPointId = "";

  /**
   * The name of the stock point
   *
   * @generated from field: string stock_point_name = 2;
   */
  stockPointName = "";

  /**
   * The available quantity of the inventory item at this stock point
   *
   * @generated from field: float available_quantity = 3;
   */
  availableQuantity = 0;

  constructor(data?: PartialMessage<InventoryStockPointSplitItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryStockPointSplitItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "available_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryStockPointSplitItem {
    return new InventoryStockPointSplitItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryStockPointSplitItem {
    return new InventoryStockPointSplitItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryStockPointSplitItem {
    return new InventoryStockPointSplitItem().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryStockPointSplitItem | PlainMessage<InventoryStockPointSplitItem> | undefined, b: InventoryStockPointSplitItem | PlainMessage<InventoryStockPointSplitItem> | undefined): boolean {
    return proto3.util.equals(InventoryStockPointSplitItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryBranchSplitItem
 */
export class InventoryBranchSplitItem extends Message<InventoryBranchSplitItem> {
  /**
   * The code of the branch
   *
   * @generated from field: string branch_code = 1;
   */
  branchCode = "";

  /**
   * The name of the branch
   *
   * @generated from field: string branch_name = 2;
   */
  branchName = "";

  /**
   * The average daily sales of the inventory item
   *
   * @generated from field: float average_daily_sales = 3;
   */
  averageDailySales = 0;

  /**
   * The average weekly sales of the inventory item
   *
   * @generated from field: float average_weekly_sales = 4;
   */
  averageWeeklySales = 0;

  /**
   * The average monthly sales of the inventory item
   *
   * @generated from field: float average_monthly_sales = 5;
   */
  averageMonthlySales = 0;

  /**
   * The total daily sales of the inventory item
   *
   * @generated from field: float total_daily_sales = 6;
   */
  totalDailySales = 0;

  /**
   * The total weekly sales of the inventory item
   *
   * @generated from field: float total_weekly_sales = 7;
   */
  totalWeeklySales = 0;

  /**
   * The total monthly sales of the inventory item
   *
   * @generated from field: float total_monthly_sales = 8;
   */
  totalMonthlySales = 0;

  /**
   * The estimated number of days the current stock will last based on sales
   *
   * @generated from field: float days_of_supply_remaining = 9;
   */
  daysOfSupplyRemaining = 0;

  constructor(data?: PartialMessage<InventoryBranchSplitItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryBranchSplitItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "branch_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "average_daily_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "average_weekly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "average_monthly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "total_daily_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "total_weekly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "total_monthly_sales", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 9, name: "days_of_supply_remaining", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryBranchSplitItem {
    return new InventoryBranchSplitItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryBranchSplitItem {
    return new InventoryBranchSplitItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryBranchSplitItem {
    return new InventoryBranchSplitItem().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryBranchSplitItem | PlainMessage<InventoryBranchSplitItem> | undefined, b: InventoryBranchSplitItem | PlainMessage<InventoryBranchSplitItem> | undefined): boolean {
    return proto3.util.equals(InventoryBranchSplitItem, a, b);
  }
}

